module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "minus.f7625ea0.svg";